export default {"src":"/_next/static/media/hand_gliding.958cc94b.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};